import { DropdownHistoryComponent } from '../../components/dn-user-menu/dropdown-history/dropdown-history.component';
// import {
//   DropdownFavoriteUpdatesComponent
// } from '../../components/dn-user-menu/dropdown-favorite-updates/dropdown-favorite-updates.component';
//import { DropdownSubscribesComponent } from '../../components/dn-user-menu/dropdown-subscribes/dropdown-subscribes.component';
import { Dropdown } from '../../components/dn-user-menu/dropdown/dropdown';
import { DropdownNotificationsComponent } from '../../components/dn-user-menu/dropdown-notifications/dropdown-notifications.component';

export const UserMenuItems = [
  // {
  //   title: '上传',
  //   authentication: true,
  //   link: '#',
  //   icon: 'icon-login',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 0,
  //   seprator: false,
  //   externalLink: false,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: null,
  //   notification: null
  // },

  // environment.cinema==2?{}:{

  //   title: '订阅',
  //   authentication: true,
  //   link: '/user/subscription',
  //   icon: 'icon-adult-1',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 100,
  //   seprator: false,
  //   externalLink: false,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: new Dropdown(DropdownSubscribesComponent, {
  //     width: 376,
  //   }),
  //   notification: null
  // },
  {
    title: '看过',
    authentication: true,
    link: '/user/watch-history',
    icon: 'iconlishijilu',
    iconSize: '',
    selected: false,
    expanded: false,
    order: 100,
    seprator: false,
    externalLink: false,
    rect: {
      left: -14,
      top: 0,
      width: 84,
      height: 0
    },
    dropdown: new Dropdown(DropdownHistoryComponent, {
      width: 376,
    }),
    notification: null
  },
  {
    title: '通知',
    authentication: true,
    link: '/user/messages',
    icon: 'icontongzhizhongxin',
    iconSize: '',
    selected: false,
    expanded: false,
    order: 100,
    seprator: false,
    externalLink: false,
    rect: {
      left: -115,
      top: 0,
      width: 84,
      height: 0
    },
    dropdown: new Dropdown(DropdownNotificationsComponent, {
      width: 376
    }),
    notification: null
  },
  // {
  //   title: '订阅',
  //   authentication: true,
  //   link: null,
  //   icon: 'icon-adult',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 200,
  //   seprator: false,
  //   externalLink: false,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: new Dropdown(DropdownSubscribesComponent, {
  //     width: 460,
  //   }),
  //   notification: 'subscribeUpdates'
  // },
  // {
  //   title: '收藏',
  //   authentication: true,
  //   link: '/user/favorites',
  //   icon: 'icon-favoritefolder',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 200,
  //   seprator: false,
  //   externalLink: false,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: new Dropdown(DropdownFavoriteUpdatesComponent, {
  //     width: 376,
  //   }),
  //   notification: '25'
  // },
  // {
  //   title: '消息',
  //   authentication: true,
  //   link: '/user/messages',
  //   icon: 'icon-messege',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 200,
  //   seprator: false,
  //   externalLink: false,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: new Dropdown(DropdownMessagesComponent, {
  //     width: 360,
  //   }),
  //   notification: '258'
  // },
  // {
  //   title: '访问旧版',
  //   authentication: false,
  //   link: 'https://www.dnvod.tv',
  //   icon: 'icon-help',
  //   iconSize: '',
  //   selected: false,
  //   expanded: false,
  //   order: 200,
  //   seprator: true,
  //   externalLink: true,
  //   rect: {
  //     left: 0,
  //     top: 0,
  //     width: 84,
  //     height: 0
  //   },
  //   dropdown: null,
  //   notification: null
  // },
].filter(p=>!!p.title);
